import { AbstractSummary } from "../campaigns/abstractSummary";



export class PlanSummary extends AbstractSummary {
}
